<template>
  <div class="adverts-group">
    <search-advert-group
      v-on:addAdvertGroup="addAdvertGroup"
      v-on:onSubmit="onSubmit"
      v-on:resetSearch="resetSearch"
      :search="search"
    >
    </search-advert-group>
    <add-advert-group
      ref="addAdvertGroup"
      v-on:cancel="cancel"
      v-on:open-machine-group-config="handleOpenMachineGroupConfig"
      v-on:add-advert="handleAddAdvert"
      :dialogAdvertGroup="dialogAdvertGroup"
      :advertGroup="advertGroup"
    >
    </add-advert-group>
    <add-adverts :adverts="adverts" :dialogAdverts.sync="dialogAdverts" @cancel="handleAdvertCancel" />
    <machine-group-config
      :visible.sync="dialogMachineGroupConfig"
      :advertGroupId="currentAdvertGroupId"
      @success="currentChange"
    />
    <play-plan-config
      :showPianoDialog.sync="dialogPlayPlanConfig"
      :advertGroupId="currentAdvertGroupId"
      @success="currentChange"
    />

    <div class="vue-padding radius">
      <el-table
        v-loading="loading"
        :empty-text="$t('common.noData')"
        :element-loading-text="$t('common.loading')"
        :data="advertGroupList"
        style="width: 100%"
        max-height="638"
        :border="true"
      >
        <el-table-column
          prop="userName"
          :show-overflow-tooltip="true"
          :label="$t('advertGroup.userName')"
          :align="'center'"
        ></el-table-column>
        <el-table-column prop="name" :label="$t('advertGroup.name')" :align="'center'"></el-table-column>
        <el-table-column
          prop="createTime"
          :label="$t('advertGroup.createTime')"
          width="170"
          :align="'center'"
        ></el-table-column>
        <el-table-column fixed="right" :label="$t('common.operate')" :align="'center'">
          <template slot-scope="scope">
            <el-button size="mini" v-hasPerm="['advert:group:update']" @click="editAdvertGroup(scope.row)">{{
              $t("common.edit")
            }}</el-button>
            <el-button size="mini" @click="openMachineGroupConfig(scope.row)" v-hasPerm="['advert:group:config']">
              {{ $t("adverts.AdvertGroup.333447-0") }}
            </el-button>
            <el-button size="mini" @click="openPlayPlanConfig(scope.row)" v-hasPerm="['advert:group:plan']">
              {{ $t("adverts.AdvertGroup.333447-1") }}
            </el-button>
            <el-button
              size="mini"
              type="danger"
              v-hasPerm="['advert:group:delete']"
              @click="deleteAdvertGroup(scope.row)"
              >{{ $t("common.delete") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total,sizes,prev, pager, next,jumper"
        :current-page="page.pageIndex"
        :total="page.totalSize"
        :page-size="page.pageSize"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
  import searchAdvertGroup from "_c/adverts/SearchAdvertGroup";
  import addAdvertGroup from "_c/adverts/AddAdvertGroup";
  import AddAdverts from "@/components/adverts/AddAdverts.vue";
  import machineGroupConfig from "_c/adverts/MachineGroupConfig";
  import playPlanConfig from "_c/adverts/PlayPlanConfig";
  export default {
    name: "AdvertsGroup",
    components: {
      searchAdvertGroup,
      addAdvertGroup,
      AddAdverts,
      machineGroupConfig,
      playPlanConfig
    },
    data() {
      return {
        search: {
          name: ""
        },
        page: {
          pageSize: 10,
          pageIndex: 1
        },
        dialogAdvertGroup: false,
        dialogMachineGroupConfig: false,
        dialogPlayPlanConfig: false,
        currentAdvertGroupId: "",
        loading: false,
        advertGroupList: [],
        advertGroup: {
          id: "",
          name: "",
          notes: "",
          display: ""
        },
        dialogAdverts: false,
        adverts: {
          id: "",
          advertType: "",
          showImage: "",
          showVideo: "",
          title: "",
          advertPrice: "",
          advertShopName: "",
          url: "",
          duration: 0,
          thumbnail: "",
          remarks: ""
        },
        showType: []
      };
    },
    mounted() {
      this.currentChange();
      this.listShowType();
    },
    methods: {
      listShowType() {
        this.$api.dict("gp_show_type").then(res => {
          if (res.code === 0) {
            this.showType = res.data;
          }
        });
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
        this.currentChange();
      },
      currentChange(pageIndex) {
        this.loading = true;
        this.page.pageIndex = pageIndex ? pageIndex : 1;
        let obj = this.$cloud.objMerge(this.search, this.page);
        this.$api
          .request(this.$url.AdvertGroup.page, this.$method.get, obj)
          .then(res => {
            if (res.code === 0) {
              this.advertGroupList = res.data.records;
              this.page.totalSize = parseInt(res.data.total);
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      },
      addAdvertGroup() {
        this.advertGroup = {
          id: "",
          name: "",
          notes: "",
          display: ""
        };
        this.dialogAdvertGroup = true;
      },
      resetSearch(data) {
        this.search = data;
        this.currentChange();
      },
      onSubmit(data) {
        this.search = data;
        this.currentChange();
      },
      cancel(dialog, status) {
        this.dialogAdvertGroup = dialog;
        if (status) {
          this.currentChange(this.page.pageIndex);
        }
      },
      editAdvertGroup(row) {
        this.dialogAdvertGroup = true;
        Object.keys(this.advertGroup).forEach(key => {
          this.advertGroup[key] = row[key];
        });
        this.advertGroup.id = row.id;
      },
      handleAddAdvert() {
        this.adverts = {
          id: "",
          advertType: "",
          showImage: "",
          showVideo: "",
          title: "",
          advertPrice: "",
          advertShopName: "",
          url: "",
          duration: 0,
          thumbnail: "",
          remarks: ""
        };
        this.dialogAdverts = true;
      },
      handleAdvertCancel(dialog, action) {
        this.dialogAdverts = dialog;
        if (action === "save" || action === "update") {
          if (this.dialogAdvertGroup) {
            this.$nextTick(() => {
              const addAdvertGroupRef = this.$refs.addAdvertGroup;
              if (addAdvertGroupRef && typeof addAdvertGroupRef.init === "function") {
                addAdvertGroupRef.init();
              }
            });
          }
        }
      },
      openMachineGroupConfig(row) {
        this.currentAdvertGroupId = row.id;
        this.dialogMachineGroupConfig = true;
      },
      handleOpenMachineGroupConfig(groupId) {
        this.currentAdvertGroupId = groupId;
        this.$nextTick(() => {
          this.dialogMachineGroupConfig = true;
        });
      },
      openPlayPlanConfig(row) {
        this.currentAdvertGroupId = row.id;
        this.dialogPlayPlanConfig = true;
      },
      deleteAdvertGroup(row) {
        this.$confirm(this.$t("advertGroup.delete"), this.$t("common.warning"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        }).then(() => {
          this.$api
            .request(this.$url.AdvertGroup.delete, this.$method.delete, {
              id: row.id
            })
            .then(res => {
              if (res.code === 0) {
                this.$notify({
                  title: this.$t("common.tip"),
                  message: res.msg,
                  type: "success"
                });
                this.currentChange(this.page.pageIndex);
              }
            });
        });
      }
    }
  };
</script>

<style>
  .el-dialog__header {
    padding: 20px;
  }
  .el-dialog__body {
    padding: 0 20px;
    height: auto !important;
  }
  .el-dialog__footer {
    padding: 20px;
  }
</style>
